<template>
    <vs-popup classContent="popup-example" :title="translate('ChangeUserPassword')" :active.sync="popUps.popupAddActive">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('NewPassword')" v-model="params.password1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('RepeatPassword')" v-model="params.password2" />
        </div>
      </div>     
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="submitForm()" color="primary" type="filled">{{translate('Save')}}</vs-button>
        </div>
      </div>
    </vs-popup>
</template>
<script>
export default {
    props:['closePopups','params','popUps','openAlert'],
    data() {
        return {}
    },
    methods:{
      translate: function(key){
        return this.$t(key);
      },   
      submitForm: function(){

      }    
    }
}
</script>